/**
 * Subscription Banner for 25+ lb variants
 * Shows a sliding banner when variants 25+ pounds are selected
 */

document.addEventListener('DOMContentLoaded', function() {
  const subscriptionBanner = document.getElementById('subscription-banner');
  const dismissBtn = document.getElementById('subscription-dismiss-btn');
  
  if (!subscriptionBanner || !dismissBtn) {
    return;
  }

  // Check if customer is B2B/wholesale - if so, don't show subscription banner
  if (window.customerTags && Array.isArray(window.customerTags)) {
    const isWholesaleCustomer = window.customerTags.some(tag => 
      tag.toLowerCase().includes('wholesale') || 
      tag.toLowerCase().includes('b2b') || 
      tag.toLowerCase().includes('upnova-wholesale')
    );
    
    if (isWholesaleCustomer) {
      // Subscription banner disabled for wholesale/B2B customer
      return;
    }
  }
  
  let bannerTimeout;
  let isBannerVisible = false;

  // Single session storage key that gets overwritten each time banner is clicked
  const SESSION_STORAGE_KEY = 'subscription_banner_last_clicked_variant';
  
  // Get current product handle and variant ID for variant-specific session storage
  function getCurrentProductHandle() {
    const path = window.location.pathname;
    const productMatch = path.match(/\/products\/([^\/]+)/);
    return productMatch ? productMatch[1] : null;
  }
  
  function getCurrentVariantId() {
    return getSelectedVariantId();
  }
  
  function hasUserClickedBanner() {
    const currentVariantId = getCurrentVariantId();
    const lastClickedVariantId = sessionStorage.getItem(SESSION_STORAGE_KEY);
    
    // Banner was clicked if the last clicked variant ID matches current variant ID
    return lastClickedVariantId && lastClickedVariantId === currentVariantId.toString();
  }
  
  function markBannerAsClicked() {
    const currentVariantId = getCurrentVariantId();
    if (currentVariantId) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, currentVariantId.toString());
    }
  }

  // Function to extract weight from text (handles various formats)
  function extractWeightFromText(text) {
    if (!text) return null;
    
    const lowerText = text.toLowerCase().trim();
    
    // Look for weight patterns: "25 lb", "25lbs", "25 pounds", "25.5 lb", etc.
    const weightPatterns = [
      /(\d+(?:\.\d+)?)\s*(?:lb|lbs|pound|pounds)/g,
      /(\d+(?:\.\d+)?)\s*(?:kg|kgs|kilogram|kilograms)/g,
      /(\d+(?:\.\d+)?)\s*(?:oz|ozs|ounce|ounces)/g,
      /(\d+(?:\.\d+)?)\s*(?:g|gram|grams)/g
    ];
    
    for (let pattern of weightPatterns) {
      const match = lowerText.match(pattern);
      if (match) {
        const weight = parseFloat(match[0].replace(/[^\d.]/g, ''));
        const unit = match[0].replace(/[\d.]/g, '').trim();
        
        // Convert to pounds for comparison
        let weightInPounds = weight;
        if (unit.includes('kg')) {
          weightInPounds = weight * 2.20462; // kg to lbs
        } else if (unit.includes('oz')) {
          weightInPounds = weight / 16; // oz to lbs
        } else if (unit.includes('g')) {
          weightInPounds = weight * 0.00220462; // g to lbs
        }
        
        return weightInPounds;
      }
    }
    
    return null;
  }

  // Function to check if current variant is 25+ pounds
  function isVariant25PlusPounds() {
    // Check if we're on a product page
    if (!window.location.pathname.includes('/products/')) {
      return false;
    }

    // Method 1: Check selected swatch text for any weight 25+ lbs
    const selectedSwatch = document.querySelector('.swatch-element input[type="radio"]:checked');
    if (selectedSwatch) {
      const swatchElement = selectedSwatch.closest('.swatch-element');
      if (swatchElement) {
        const swatchLabel = swatchElement.querySelector('label');
        if (swatchLabel) {
          const labelText = swatchLabel.textContent;
          
          const weight = extractWeightFromText(labelText);
          if (weight && weight >= 25) {
            return true;
          }
        }
      }
    }

    // Method 2: Check variant select dropdown for any weight 25+ lbs
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (selectedOption) {
        const optionText = selectedOption.text;
        
        const weight = extractWeightFromText(optionText);
        if (weight && weight >= 25) {
          return true;
        }
      }
    }

    // Method 3: Check for active/selected variant elements
    const activeSwatch = document.querySelector('.swatch-element.active, .swatch-element.selected');
    if (activeSwatch) {
      const activeLabel = activeSwatch.querySelector('label');
      if (activeLabel) {
        const activeText = activeLabel.textContent;
        // Active swatch text detected
        
        const weight = extractWeightFromText(activeText);
        if (weight && weight >= 25) {
          // Found 25+ lb variant in active swatch
          return true;
        }
      }
    }

    // Method 4: Check for highlighted/selected variant
    const highlightedSwatch = document.querySelector('.swatch-element[style*="background"], .swatch-element.selected');
    if (highlightedSwatch) {
      const highlightedLabel = highlightedSwatch.querySelector('label');
      if (highlightedLabel) {
        const highlightedText = highlightedLabel.textContent;
        // Highlighted swatch text detected
        
        const weight = extractWeightFromText(highlightedText);
        if (weight && weight >= 25) {
          // Found 25+ lb variant in highlighted swatch
          return true;
        }
      }
    }

    // Method 5: Check window.product data for variant titles
    if (window.product && window.product.variants) {
      const selectedVariantId = getSelectedVariantId();
      if (selectedVariantId) {
        const currentVariant = window.product.variants.find(v => v.id === selectedVariantId);
        if (currentVariant && currentVariant.title) {
          const variantTitle = currentVariant.title;
          // Variant title from product data
          
          const weight = extractWeightFromText(variantTitle);
          if (weight && weight >= 25) {
            // Found 25+ lb variant in product data
            return true;
          }
        }
      }
    }

    return false;
  }

  // Function to check if current variant is under 25 pounds
  function isVariantUnder25Pounds() {
    // Check if we're on a product page
    if (!window.location.pathname.includes('/products/')) {
      return false;
    }

    // Method 1: Check selected swatch text for any weight under 25 lbs
    const selectedSwatch = document.querySelector('.swatch-element input[type="radio"]:checked');
    if (selectedSwatch) {
      const swatchElement = selectedSwatch.closest('.swatch-element');
      if (swatchElement) {
        const swatchLabel = swatchElement.querySelector('label');
        if (swatchLabel) {
          const labelText = swatchLabel.textContent;
          // Selected swatch text detected
          
          const weight = extractWeightFromText(labelText);
          if (weight && weight < 25) {
            // Found under 25lb variant in swatch
            return true;
          }
        }
      }
    }

    // Method 2: Check variant select dropdown for any weight under 25 lbs
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (selectedOption) {
        const optionText = selectedOption.text;
        // Selected option text detected
        
        const weight = extractWeightFromText(optionText);
        if (weight && weight < 25) {
          // Found under 25lb variant in select
          return true;
        }
      }
    }

    // Method 3: Check for active/selected variant elements
    const activeSwatch = document.querySelector('.swatch-element.active, .swatch-element.selected');
    if (activeSwatch) {
      const activeLabel = activeSwatch.querySelector('label');
      if (activeLabel) {
        const activeText = activeLabel.textContent;
        // Active swatch text detected
        
        const weight = extractWeightFromText(activeText);
        if (weight && weight < 25) {
          // Found under 25lb variant in active swatch
          return true;
        }
      }
    }

    // Method 4: Check for highlighted/selected variant
    const highlightedSwatch = document.querySelector('.swatch-element[style*="background"], .swatch-element.selected');
    if (highlightedSwatch) {
      const highlightedLabel = highlightedSwatch.querySelector('label');
      if (highlightedLabel) {
        const highlightedText = highlightedLabel.textContent;
        // Highlighted swatch text detected
        
        const weight = extractWeightFromText(highlightedText);
        if (weight && weight < 25) {
          // Found under 25lb variant in highlighted swatch
          return true;
        }
      }
    }

    // Method 5: Check window.product data for variant titles
    if (window.product && window.product.variants) {
      const selectedVariantId = getSelectedVariantId();
      if (selectedVariantId) {
        const currentVariant = window.product.variants.find(v => v.id === selectedVariantId);
        if (currentVariant && currentVariant.title) {
          const variantTitle = currentVariant.title;
          // Variant title from product data
          
          const weight = extractWeightFromText(variantTitle);
          if (weight && weight < 25) {
            // Found under 25lb variant in product data
            return true;
          }
        }
      }
    }

    // No under 25lb variant detected
    return false;
  }

  // Function to get selected variant ID
  function getSelectedVariantId() {
    // Check variant select dropdown
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      return parseInt(variantSelect.value);
    }
    
    // Check swatch inputs
    const selectedSwatch = document.querySelector('.swatch-element input[type="radio"]:checked');
    if (selectedSwatch && selectedSwatch.value) {
      return parseInt(selectedSwatch.value);
    }
    
    return null;
  }

  // Function to show banner
  function showSubscriptionBanner() {
    // Don't show banner if user has already clicked it to refresh for the current variant
    if (hasUserClickedBanner()) {
      // Banner already clicked by user for current variant, not showing again
      return;
    }
    
    // Showing subscription banner for 25+ lb variant
    
    // Clear any existing timeout first
    if (bannerTimeout) {
      clearTimeout(bannerTimeout);
      bannerTimeout = null;
    }
    
    // If banner is already visible, hide it first then show new one
    if (isBannerVisible) {
      // Banner already visible, hiding first
      subscriptionBanner.classList.remove('show');
      isBannerVisible = false;
      
      // Wait for hide animation to complete, then show new banner
      setTimeout(() => {
        subscriptionBanner.style.display = 'block';
        // Trigger reflow
        subscriptionBanner.offsetHeight;
        subscriptionBanner.classList.add('show');
        isBannerVisible = true;
        
        // Auto-hide after 5 seconds
        bannerTimeout = setTimeout(() => {
          hideSubscriptionBanner();
        }, 5000);
      }, 400); // Wait for hide animation
    } else {
      // Show banner normally
      subscriptionBanner.style.display = 'block';
      // Trigger reflow
      subscriptionBanner.offsetHeight;
      subscriptionBanner.classList.add('show');
      isBannerVisible = true;
      
      // Auto-hide after 5 seconds
      bannerTimeout = setTimeout(() => {
        hideSubscriptionBanner();
      }, 5000);
    }
  }

  // Function to hide banner
  function hideSubscriptionBanner() {
    if (!isBannerVisible) return;
    
    // Hiding subscription banner
    
    // Clear any existing timeout
    if (bannerTimeout) {
      clearTimeout(bannerTimeout);
      bannerTimeout = null;
    }
    
    subscriptionBanner.classList.remove('show');
    isBannerVisible = false;
    
    // Hide completely after animation
    setTimeout(() => {
      subscriptionBanner.style.display = 'none';
    }, 400);
  }

  // Function to refresh page
  function refreshPage() {
    // Refreshing page to show subscription options
    markBannerAsClicked(); // Mark banner as clicked for current variant before refreshing
    window.location.reload();
  }

  // Event listeners
  subscriptionBanner.addEventListener('click', function(e) {
    // Only refresh if not clicking the dismiss button
    if (e.target !== dismissBtn && !dismissBtn.contains(e.target)) {
      refreshPage();
    }
  });
  
  dismissBtn.addEventListener('click', function(e) {
    e.stopPropagation(); // Prevent banner click
    hideSubscriptionBanner();
  });

  // Check for variant changes
  function checkVariantAndShowBanner() {
    
    if (isVariant25PlusPounds()) {
      showSubscriptionBanner();
    } else if (isVariantUnder25Pounds()) {
      hideSubscriptionBanner();
    } else {
      hideSubscriptionBanner();
    }
  }

  // Listen for variant changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('select[name="id"]') || 
        e.target.matches('.swatch-element input[type="radio"]')) {
      // Variant changed, checking in 100ms
      setTimeout(checkVariantAndShowBanner, 100);
    }
  });

  // Listen for clicks on swatch elements
  document.addEventListener('click', function(e) {
    if (e.target.closest('.swatch-element')) {
      // Swatch clicked, checking in 200ms
      setTimeout(checkVariantAndShowBanner, 200);
    }
  });

  // Listen for Shopify variant change events
  document.addEventListener('variant:changed', function() {
    // Shopify variant changed event
    checkVariantAndShowBanner();
  });

  // Check on page load
  setTimeout(checkVariantAndShowBanner, 500);

  // Also check when product data is available
  if (window.product) {
    checkVariantAndShowBanner();
  } else {
    // Wait for product data to load
    const checkForProduct = setInterval(() => {
      if (window.product) {
        clearInterval(checkForProduct);
        checkVariantAndShowBanner();
      }
    }, 100);
  }
});
